<template>
  <div>
    <table-component
      ref="tableComponent"
      :model="model"
      :show-form="false"
      :url-create-form="'/accounts/create/' + accountType"
      url-edit-form="/accounts/edit"
      force-paginate
      :permissions="permissions"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Account from '@/dc-it/models/Account'

export default {
  name: 'DebitAccountsView',
  components: { TableComponent },
  data() {
    return {
      model: Account,
      // accountType: null,
      permissions: {
        create: true,
        edit: true,
        delete: false,
        filter: true,
      },
      accountType: 1,
    }
  },
  mounted() {
    this.applyFilter()
  },
  methods: {
    applyFilter() {
      this.$refs.tableComponent.filterFields = [
        {
          field: 'account_type.type',
          value: this.accountType,
        },
      ]
      this.$refs.tableComponent.applyFilter()
    },
  },
}
</script>

<style scoped>

</style>
